module.exports = __webpack_public_path__ + "img/collect.654359bc.png";